import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import { useMemo } from 'react';
import { antdUploadRequest } from 'utils/antd-upload-request';

const FormImageUpload = ({
  value,
  onChange,
  maxCount = 1,
}: {
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
  maxCount?: number;
}) => {
  const arr = useMemo(() => {
    if (!value) return [];

    return Array.isArray(value) ? value : [value];
  }, [value]);

  return (
    <div className="flex gap-4">
      {arr.map((url, index) => {
        return (
          <div key={url} className="relative">
            <img
              src={url}
              alt=""
              className="w-36 h-36 object-cover border border-dashed"
            />
            <DeleteOutlined
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 cursor-pointer"
              onClick={() => {
                if (!onChange) return;
                if (maxCount === 1) {
                  onChange('');
                } else if (Array.isArray(value)) {
                  const newUrls = value.filter((_, i) => i !== index);
                  onChange(newUrls);
                }
              }}
            />
          </div>
        );
      })}
      {arr.length < maxCount && (
        <Upload
          className="w-36 h-36 flex justify-center items-center border border-dashed rounded cursor-pointer"
          customRequest={antdUploadRequest}
          showUploadList={false}
          onChange={(e) => {
            const url = e.file?.response?.data?.url;

            if (!url) return;
            if (!onChange) return;

            if (maxCount === 1) {
              onChange(url);
            } else {
              if (!value) {
                onChange([url]);
              } else if (Array.isArray(value)) {
                onChange([...value, url]);
              } else {
                throw Error('当 value 为 string时, maxCount 必须为 1');
              }
            }
          }}
        >
          <PlusOutlined className="w-36 h-36 flex justify-center items-center" />
        </Upload>
      )}
    </div>
  );
};

export default FormImageUpload;
